import { ImagePreview } from '@app/entities/images/interfaces/image-preview';
import { Selector } from '@ngxs/store';
import { GalleryStateModel } from './gallery-state.model';
import { GalleryState } from './gallery.state';
import { PricingFilterValues } from '@app/pages/gallery/pricing-filter/pricing-filter-values';
import { OrientationFilterValues } from '@app/pages/gallery/orientation-filter/orientation-filter-values';
import { SortingOptionsValues } from '@app/pages/gallery/sorting-options/sorting-options-values';
import { ContentTypeFilterValues } from '@app/pages/gallery/content-type-filter/content-type-filter-values';

export class GallerySelectors {
  @Selector([GalleryState])
  static images(state: GalleryStateModel): ImagePreview[] | undefined {
    return state.images;
  }

  @Selector([GalleryState])
  static hasMoreResults(state: GalleryStateModel): boolean {
    return (state?.images?.length || 0) < (state?.totalCount || 0);
  }

  @Selector([GalleryState])
  static searchRequest(state: GalleryStateModel): string {
    return state.searchRequest;
  }

  @Selector([GalleryState])
  static category(state: GalleryStateModel): string | undefined {
    return state.category;
  }

  @Selector([GalleryState])
  static tags(state: GalleryStateModel): string[] {
    return state.tags;
  }

  @Selector([GalleryState])
  static isFree(state: GalleryStateModel): PricingFilterValues {
    return state.isFree;
  }

  @Selector([GalleryState])
  static type(state: GalleryStateModel): ContentTypeFilterValues[] {
    return state.type;
  }

  @Selector([GalleryState])
  static orientation(state: GalleryStateModel): OrientationFilterValues {
    return state.orientation;
  }

  @Selector([GalleryState])
  static ordering(state: GalleryStateModel): SortingOptionsValues {
    return state.ordering;
  }
}
